import { Select } from 'antd';
import React, { Component } from 'react'
const Option = Select.Option;

export default class InvServiceContent extends Component {

    handelDomRender = () => {
        const { Config, type, handleEvaluateServeChange } = this.props;
        return Config.map((item, itemIndex) => {
            const { evaluateServeId, evaluateServeName, children, markRed: fatherMarkRed } = item;
            // const fatherDom = <div className='item_father'>
            //     <span className='item_father_text' style={{ color: fatherMarkRed ? 'red' : undefined }}>{evaluateServeName}</span>
            // </div>;
            const childrenDom = <div className='item_child' style={{ width: '100%' }}>
                {
                    children.map((child, childIndex) => {
                        const { evaluateServeId, evaluateServeName, children, markRed: leftChildMarkRed } = child;
                        let selectValue = [];
                        let selectNameValue = [];
                        children.map(option => {
                            const { selected } = option;
                            if(selected) selectNameValue.push({name: option.evaluateServeName, isRed: option.markRed });
                        })
                        return <div className='item_child_item' key={evaluateServeId}>
                            <div className='item_child_left' style={{ color: leftChildMarkRed ? 'red' : undefined }}>{evaluateServeName}</div>
                            <div className='item_child_right'>
                                {
                                    type === 'edit' ?
                                        <Select
                                            style={{
                                                width: '90%'
                                            }}
                                            mode="multiple"
                                            value={selectValue}
                                            placeholder="请选择"
                                            onDeselect={(value) => {
                                                Config.map(a => {
                                                    a.children.map(b => {
                                                        b.children.map(c => {
                                                            if(c.evaluateServeId == value){
                                                                c.selected = false
                                                            }
                                                        })
                                                    })
                                                })
                                                handleEvaluateServeChange(JSON.stringify(Config))
                                            }}
                                            onSelect={(_, option) => {
                                                const { props:{
                                                    itemIndex,
                                                    childIndex,
                                                    optionIndex,
                                                }} = option;
                                                if (evaluateServeId == 10) {
                                                    //"中心快速启动服务"下拉框该为单选
                                                    Config[itemIndex].children[childIndex].children.map((el, index) => {
                                                        el.selected = index === optionIndex;
                                                    });
                                                } else {
                                                    Config[itemIndex].children[childIndex].children[optionIndex].selected = true;
                                                }
                                                handleEvaluateServeChange(JSON.stringify(Config))
                                            }}
                                        >
                                            {
                                                children.map((option, optionIndex) => {
                                                        const { selected } = option;
                                                        if(selected) selectValue.push(option.evaluateServeId);
                                                        return <Option 
                                                            itemIndex={itemIndex}
                                                            childIndex={childIndex}
                                                            optionIndex={optionIndex}
                                                            selected={selected}
                                                            key={option.evaluateServeId}
                                                            value={option.evaluateServeId}
                                                        >{option.evaluateServeName}</Option>
                                                    }
                                                )
                                            }
                                        </Select> : 
                                        <span>
                                            {
                                                selectNameValue.map((el, index) => <span style={{ color: el.isRed ? 'red' : undefined}}>{el.name}{index === selectNameValue.length - 1 ? '' : '，'}</span>)
                                            }
                                        </span>
                                }
                                
                            </div>
                        </div>
                    })
                }
            </div>
            return <div className='invServiceContent_item' key={evaluateServeId}>
                {/* {fatherDom} */}
                {childrenDom}
            </div>
        })
    }

    render() {
        return (
            <div className='invServiceContent_edit'>
                {
                    this.handelDomRender()
                }
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/clinicalEvaluation/clinicalEvaluationRecord/components/InvServiceContent.js